import type { ComponentProps } from 'react';
import { Badge } from '@src/design-system/badge';
import {
  REMINDER_LOG_STATUSES,
  type TReminderLogStatus,
} from '@src/shared/types/reminder';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { cn } from '@src/design-system/helpers';

const STATUS_PRESENTATION: Record<
  TReminderLogStatus,
  {
    label: string;
    variant: ComponentProps<typeof Badge>['variant'];
    className?: string;
  }
> = {
  [REMINDER_LOG_STATUSES.pending]: { label: 'Scheduled', variant: 'warning' },
  [REMINDER_LOG_STATUSES.sent]: {
    label: 'Sent',
    variant: 'secondary',
    className: 'text-blue-500! bg-blue-100!',
  },
  [REMINDER_LOG_STATUSES.delivered]: {
    label: 'Delivered',
    variant: 'success',
    className: 'text-primary-1000! bg-primary-100!',
  },
  [REMINDER_LOG_STATUSES.failed]: { label: 'Failed', variant: 'danger' },
  [REMINDER_LOG_STATUSES.bounced]: {
    label: 'Bounced',
    variant: 'default',
    className: 'text-gray-800! bg-gray-100!',
  },
  [REMINDER_LOG_STATUSES.opened]: {
    label: 'Read',
    variant: 'primaryBlue',
    className: 'text-green-500! bg-green-100!',
  },
};

export function LogStatusBadge({ status }: { status: TReminderLogStatus }) {
  const cfg = STATUS_PRESENTATION[status] ?? {
    label: formatTextForDisplay(status),
    variant: 'default' as const,
  };
  return (
    <Badge
      className={cn('p-2 rounded-xl', cfg.className)}
      variant={cfg.variant}
    >
      {cfg.label}
    </Badge>
  );
}
